"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5639],{

/***/ 35639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AuthContext": function() { return /* binding */ AuthContext; },
  "AuthProvider": function() { return /* binding */ AuthProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/configs/auth.js
/* harmony default export */ var auth = ({
    meEndpoint: "/auth/me",
    loginEndpoint: "/jwt/login",
    registerEndpoint: "/jwt/register",
    storageTokenKeyName: "accessToken",
    onTokenExpiration: "refreshToken" // logout | refreshToken
});

// EXTERNAL MODULE: ./src/utils/reviewFormDraft.js
var reviewFormDraft = __webpack_require__(80979);
// EXTERNAL MODULE: ./src/@api/login.js + 2 modules
var login = __webpack_require__(68980);
// EXTERNAL MODULE: ./src/utils/userDeviceList.js
var userDeviceList = __webpack_require__(35064);
// EXTERNAL MODULE: ./src/utils/appDeviceBridge.js
var appDeviceBridge = __webpack_require__(23077);
// EXTERNAL MODULE: ./src/utils/bootstrapDeviceSelection.js
var bootstrapDeviceSelection = __webpack_require__(70173);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/store/index.js + 1 modules
var store = __webpack_require__(89365);
// EXTERNAL MODULE: ./src/utils/leaveBindingFlow.js
var leaveBindingFlow = __webpack_require__(9839);
// EXTERNAL MODULE: ./src/components/expired-purchase-guide/constants.js
var constants = __webpack_require__(8009);
// EXTERNAL MODULE: ./src/utils/chooseDeviceRedirect.js
var chooseDeviceRedirect = __webpack_require__(99518);
// EXTERNAL MODULE: ./src/utils/userEntryGate.js
var userEntryGate = __webpack_require__(1128);
;// CONCATENATED MODULE: ./src/context/AuthContext.js
// ** React Imports


// ** Next Import

// ** Axios

// ** Config


const bUrl = (/* unused pure expression or super */ null && ("https://strapi.spyx.com"));
const clientURL = "https://spyx.com";
// ** Defaults
const defaultProvider = {
    user: null,
    loading: true,
    setUser: ()=>null,
    setLoading: ()=>Boolean,
    login: ()=>Promise.resolve(),
    logout: ()=>Promise.resolve(),
    register: ()=>Promise.resolve()
};
const AuthContext = /*#__PURE__*/ (0,react.createContext)(defaultProvider);
// request










const getParams = (url)=>{
    try {
        url = url.match(/\?([^#]+)/)[1];
        const obj = {};
        const arr = url.split("&");
        for(let i = 0; i < arr.length; i++){
            let subArr = arr[i].split("=");
            let key = decodeURIComponent(subArr[0]);
            let value = decodeURIComponent(subArr[1]);
            obj[key] = value;
        }
        return obj;
    } catch (err) {
        return null;
    }
};
const readStoredJson = function(key) {
    let fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
        return fallback;
    }
};
var ref, ref1;
const getDeviceId = (device)=>{
    return (ref1 = (ref = device === null || device === void 0 ? void 0 : device.id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.device_id) !== null && ref1 !== void 0 ? ref1 : "";
};
const USER_DEVICE_RETRY_BASE_DELAY_MS = 1000;
const USER_DEVICE_RETRY_MAX_DELAY_MS = 30000;
const USER_DEVICE_REQUEST_TIMEOUT_MS = 60000;
const wait = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
/**
 * 保持认证 loading 直到 user-device 返回有效列表；失败时退避后持续重试。
 * 接口成功返回空数组仍视为有效响应，由后续设备选择逻辑处理空设备状态。
 */ const getUserDevicesWithRetry = async ()=>{
    let attempt = 0;
    while(true){
        try {
            const response = await (0,userDeviceList/* getUserDeviceList */.ix)({
                forceRefresh: true,
                requestConfig: {
                    timeout: USER_DEVICE_REQUEST_TIMEOUT_MS
                }
            });
            if (Array.isArray(response === null || response === void 0 ? void 0 : response.data)) return response;
            throw new Error("Unexpected user-device response");
        } catch (error) {
            attempt += 1;
            const delay = Math.min(USER_DEVICE_RETRY_BASE_DELAY_MS * 2 ** (attempt - 1), USER_DEVICE_RETRY_MAX_DELAY_MS);
            ;
            await wait(delay);
        }
    }
};
/**
 * 直达功能页并刷新时，Redux 会重新初始化，而设备选择原本只在首页完成。
 * 在放开受保护页面渲染前恢复当前设备，避免短暂落入「绑定设备」状态。
 */ const restoreDeviceSelection = async ()=>{
    const response = await getUserDevicesWithRetry();
    const devices = response.data;
    const currentMode = localStorage.getItem("currentMode") || "";
    const savedDeviceUser = readStoredJson("DeviceUser", {}) || {};
    const savedCurrentDevice = readStoredJson("currentDevice", {}) || {};
    var _device_id;
    const savedDeviceId = (_device_id = savedDeviceUser.device_id) !== null && _device_id !== void 0 ? _device_id : savedDeviceUser.id;
    const matchedDevice = devices.find((device)=>{
        const sameId = savedDeviceId != null && savedDeviceId !== "" && String(getDeviceId(device)) === String(savedDeviceId);
        const sameUsername = !sameId && savedDeviceUser.username && device.iCloud_username === savedDeviceUser.username;
        return (sameId || sameUsername) && (!currentMode || device.platform_type === currentMode);
    });
    // 仅恢复仍可选（active/grace）的保存设备；永不回退到超 30 天设备
    const preferredDevice = matchedDevice && (0,subscriptionStatus/* isSelectableDevice */.He)(matchedDevice) ? matchedDevice : null;
    let validUnbound = [];
    try {
        const notBindOrder = await (0,login.getNotBindOrder)().catch(()=>({
                data: []
            }));
        validUnbound = (0,chooseDeviceRedirect/* filterValidUnboundOrders */.tA)(notBindOrder === null || notBindOrder === void 0 ? void 0 : notBindOrder.data);
    } catch (e) {
        validUnbound = [];
    }
    const flags = await (0,userEntryGate/* loadUserEntryFlags */.lf)();
    const entryType = (0,userEntryGate/* resolveUserEntry */.Ji)({
        flags,
        devices,
        validUnboundOrders: validUnbound
    });
    // 全部订单过期超 30 天 → 过期页；未购买的跳转由首页统一处理，深层页面不强制改道
    if (entryType === userEntryGate/* USER_ENTRY.EXPIRED */.Tv.EXPIRED) {
        // User Guide / settings 等白名单页允许访问，勿踢回续费页
        if ( true && !window.location.pathname.includes("expired-purchase") && !(0,constants/* isExpiredPurchaseRedirectExcludedPath */.M5)(window.location.pathname)) {
            window.location.assign(constants/* EXPIRED_PURCHASE_PATH */.UU);
        }
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
        return;
    }
    const entry = (0,subscriptionStatus/* resolveInitialEntry */.Mi)({
        devices,
        validUnboundOrders: validUnbound,
        preferredMode: currentMode || null,
        preferredDevice
    });
    if (entry.type !== "device" || !entry.device) {
        // 无可选绑定设备：清空选中，避免残留 lapsed DeviceUser
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
        (0,bootstrapDeviceSelection/* bootstrapDeviceSelection */.S)({
            dispatch: store/* store.dispatch */.h.dispatch,
            device: null,
            platformType: currentMode || "iOS-Cloud",
            allDevices: devices,
            currentDevice: {}
        });
        return;
    }
    const device = entry.device;
    const isSameAsSaved = preferredDevice && String(getDeviceId(preferredDevice)) === String(getDeviceId(device));
    // 只有恢复同一可选设备时才复用物理设备，切到兜底账号时必须清空。
    (0,bootstrapDeviceSelection/* bootstrapDeviceSelection */.S)({
        dispatch: store/* store.dispatch */.h.dispatch,
        device,
        allDevices: devices,
        currentDevice: isSameAsSaved ? savedCurrentDevice : {}
    });
};
const AuthProvider = (param)=>{
    let { children  } = param;
    // ** States
    const [user, setUser] = (0,react.useState)(defaultProvider.user);
    const [loading, setLoading] = (0,react.useState)(defaultProvider.loading);
    const { asPath  } = (0,next_router.useRouter)();
    // ** Hooks
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const initAuth = async ()=>{
            const getParams = (url)=>{
                try {
                    url = url.match(/\?([^#]+)/)[1];
                    const obj = {};
                    const arr = url.split("&");
                    for(let i = 0; i < arr.length; i++){
                        let subArr = arr[i].split("=");
                        let key = decodeURIComponent(subArr[0]);
                        let value = decodeURIComponent(subArr[1]);
                        obj[key] = value;
                    }
                    return obj;
                } catch (err) {
                    return null;
                }
            };
            const urlParams = getParams(location.search);
            let accessToken = window.localStorage.getItem(auth.storageTokenKeyName);
            if (urlParams != null) {
                const normalizedInboundToken = urlParams.token || urlParams.accessToken || urlParams.access_token;
                // 退出登录
                if (normalizedInboundToken == "clear") {
                    (0,reviewFormDraft/* clearReviewFormDraftsForLogout */.iV)();
                    window.localStorage.removeItem("userData");
                    window.localStorage.removeItem(auth.storageTokenKeyName);
                    localStorage.removeItem("Basic");
                    localStorage.removeItem("Advanced");
                    localStorage.removeItem("DeviceUser");
                    localStorage.removeItem("currentDevice", JSON.stringify({}));
                    window.location.href = "".concat(clientURL, "/login?q=clear");
                    return;
                }
                if (normalizedInboundToken && normalizedInboundToken != accessToken) {
                    localStorage.setItem("Basic", 0);
                    localStorage.setItem("Advanced", 0);
                    localStorage.setItem("DeviceUser", JSON.stringify({}));
                    localStorage.setItem("currentDevice", JSON.stringify({}));
                    window.localStorage.setItem(auth.storageTokenKeyName, normalizedInboundToken);
                }
            } else if (accessToken == null) {
                if (window.location.pathname.substring(1) === "user-guide-ios" || window.location.pathname.substring(1) === "user-guide-android" || window.location.pathname.substring(4) === "user-guide-ios" || window.location.pathname.substring(4) === "user-guide-android" || window.location.pathname.substring(1) === "back-up-android" || window.location.pathname.substring(1) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-android") {
                    location.href = "".concat("https://spyx.com", "/login?guide=").concat(location.href);
                    return;
                }
                window.location.href = "".concat("https://spyx.com", "/login");
            }
            let token = window.localStorage.getItem(auth.storageTokenKeyName);
            if (token) {
                let user = await (0,login.getUserInfo)();
                localStorage.setItem("userInfo", JSON.stringify(user.data));
                const appBridgeResult = await (0,appDeviceBridge/* handleAppDeviceBridge */.XD)(location.search);
                // App 深链已按 user_device_id 完成设备切换；普通 F5 则在首屏前恢复设备上下文。
                if (!(appBridgeResult === null || appBridgeResult === void 0 ? void 0 : appBridgeResult.handled) && !(0,leaveBindingFlow/* isBindingFlowPath */.b)(window.location.pathname)) {
                    try {
                        await restoreDeviceSelection();
                    } catch (error) {
                        ;
                    }
                }
                // let allUserDevice = await getAllUserDevice({})
                // if (allUserDevice.data !== null && allUserDevice.data.length > 0) {
                //   let getDeviceUser = localStorage.getItem('DeviceUser')
                //   if (getDeviceUser == null || getDeviceUser == '{}') {
                //     localStorage.setItem(
                //       'DeviceUser',
                //       JSON.stringify({
                //         username: allUserDevice.data[0].iCloud_username,
                //         password: allUserDevice.data[0].iCloud_password,
                //         temporary: allUserDevice.data[0].temporary,
                //         expire_time: allUserDevice.data[0].expire_time
                //       })
                //     )
                //   } else {
                //     let check = allUserDevice.data.find(row => row.iCloud_username == JSON.parse(getDeviceUser).username)
                //     if (!check) {
                //       localStorage.setItem(
                //         'DeviceUser',
                //         JSON.stringify({
                //           username: allUserDevice.data[0].iCloud_username,
                //           password: allUserDevice.data[0].iCloud_password,
                //           temporary: allUserDevice.data[0].temporary,
                //           expire_time: allUserDevice.data[0].expire_time
                //         })
                //       )
                //     }
                //   }
                //   if (
                //     JSON.parse(localStorage.getItem('DeviceUser')).username == null ||
                //     JSON.parse(localStorage.getItem('DeviceUser')).password == null ||
                //     JSON.parse(localStorage.getItem('DeviceUser')).username == '' ||
                //     JSON.parse(localStorage.getItem('DeviceUser')).password == ''
                //   ) {
                //     localStorage.setItem('Basic', 0)
                //   } else {
                //     localStorage.setItem('Basic', 1)
                //   }
                //   localStorage.setItem('BasicTips', 1)
                //   localStorage.setItem('Advanced', 1)
                //   localStorage.setItem('allDeviceUser', JSON.stringify(allUserDevice.data))
                // } else {
                //   localStorage.setItem('BasicTips', 0)
                //   localStorage.setItem('Basic', 0)
                //   localStorage.setItem('Advanced', 0)
                //   localStorage.setItem('allDeviceUser', JSON.stringify([]))
                // }
                user.role = "admin";
                setLoading(true);
                setUser(user);
                window.localStorage.setItem("userData", JSON.stringify(user));
                setLoading(false);
            } else {
                setLoading(false);
            }
        };
        initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleLogin = (params, errorCallback)=>{};
    const handleLogout = ()=>{
        (0,reviewFormDraft/* clearReviewFormDraftsForLogout */.iV)();
        setUser(null);
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem(auth.storageTokenKeyName);
        localStorage.removeItem("Basic");
        localStorage.removeItem("Advanced");
        localStorage.removeItem("DeviceUser");
        localStorage.removeItem("currentDevice", JSON.stringify({}));
        window.location.href = "".concat(clientURL, "/login?q=clear");
    };
    const values = {
        user,
        loading,
        setUser,
        setLoading,
        login: handleLogin,
        logout: handleLogout
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: values,
        children: children
    });
};



/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XD": function() { return /* binding */ handleAppDeviceBridge; },
/* harmony export */   "bI": function() { return /* binding */ getDashboardPathByPlatform; }
/* harmony export */ });
/* unused harmony exports parseSearchParams, applyUserDeviceById */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68980);
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83989);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89365);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29143);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99199);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38365);






/**
 * 解析 URL search 为键值对象。
 * @param {string} search - 如 ?from_app=1&user_device_id=123
 * @returns {Object|null}
 */ const parseSearchParams = (search)=>{
    try {
        var ref;
        const query = (ref = search.match(/\?([^#]+)/)) === null || ref === void 0 ? void 0 : ref[1];
        if (!query) return null;
        const obj = {};
        query.split("&").forEach((pair)=>{
            const [key, value = ""] = pair.split("=");
            if (!key) return;
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        });
        return obj;
    } catch (e) {
        return null;
    }
};
/**
 * 按平台类型返回对应 Dashboard 路径。
 * @param {string} platformType
 * @returns {string}
 */ const getDashboardPathByPlatform = (platformType)=>{
    if (platformType === "Android-Cloud") return "/android/dashboard";
    if (platformType === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};
/**
 * 按 user_device_id 选中设备并走 switchDevice。
 * @param {string|number} userDeviceId
 * @returns {Promise<{ ok: boolean, platformType?: string, dashboardPath?: string, error?: string }>}
 */ const applyUserDeviceById = async (userDeviceId)=>{
    const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
    const devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
    const device = devices.find((item)=>String(item.id) === String(userDeviceId));
    if (!device) {
        return {
            ok: false,
            error: "not_found"
        };
    }
    if (!(0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_5__/* .isSelectableDevice */ .He)(device)) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    const deviceUser = buildDeviceUserPayload(device);
    localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    localStorage.setItem("currentDevice", JSON.stringify({}));
    localStorage.setItem("Basic", device.iCloud_username ? 1 : 0);
    // 统一更新 localStorage 和切换状态；Redux 选中值保持为 device_id。
    const switched = (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__/* .switchDevice */ .m)({
        dispatch: src_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch,
        deviceUser,
        currentDevice: {},
        currentMode: device.platform_type
    });
    if (!switched) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    return {
        ok: true,
        platformType: device.platform_type,
        dashboardPath: getDashboardPathByPlatform(device.platform_type)
    };
};
/**
 * App 深链入站：解析 from_app / user_device_id 并切换设备。
 * @param {string} search - window.location.search
 * @returns {Promise<{ handled: boolean, ok?: boolean, error?: string }>}
 */ const handleAppDeviceBridge = async (search)=>{
    const params = parseSearchParams(search);
    if (!params || params.from_app !== "1") {
        return {
            handled: false
        };
    }
    // App 跳转来源平台持久化；入参可能是 iOS/Android，写入前统一小写
    if (params.app_platform) {
        sessionStorage.setItem("app_platform", String(params.app_platform).trim().toLowerCase());
    }
    const userDeviceId = params.user_device_id;
    // 绑定/setup 场景只需 orderId，device id 非必须；无 user_device_id 时不提示、不处理设备桥接
    if (!userDeviceId) {
        return {
            handled: false
        };
    }
    try {
        const result = await applyUserDeviceById(userDeviceId);
        if (!result.ok) {
            const locale = localStorage.getItem("locale") || "en";
            (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getStaticTranslation */ .Ok)("Invalid device. Please try again.", locale).then(src_components_Message__WEBPACK_IMPORTED_MODULE_3__/* .messageInfo */ .B);
            return {
                handled: true,
                ok: false,
                error: result.error
            };
        }
        const { dashboardPath  } = result;
        if (window.location.pathname !== dashboardPath) {
            window.location.assign(dashboardPath);
            return {
                handled: true,
                ok: true,
                ...result
            };
        }
        if (window.location.search) {
            window.history.replaceState(null, "", dashboardPath);
        }
        return {
            handled: true,
            ok: true,
            ...result
        };
    } catch (e) {
        const locale1 = localStorage.getItem("locale") || "en";
        (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getStaticTranslation */ .Ok)("Network error, please try again", locale1).then(src_components_Message__WEBPACK_IMPORTED_MODULE_3__/* .messageInfo */ .B);
        return {
            handled: true,
            ok: false,
            error: "request_failed"
        };
    }
};


/***/ }),

/***/ 70173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ bootstrapDeviceSelection; }
/* harmony export */ });
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83989);
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96613);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38365);



/**
 * 登录/首页选默认设备，与侧栏 switchDevice 走同一套流程。
 * 永不选中超 30 天失效设备；若传入 lapsed 会自动回退到可选设备或清空选中。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.device] - 选中的设备记录
 * @param {string} [params.platformType] - 平台类型
 * @param {Array} [params.allDevices] - 全部设备列表，写入 allDeviceUser
 * @param {Object} [params.currentDevice] - 当前物理设备；刷新恢复会话时保留
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */ const bootstrapDeviceSelection = (param)=>{
    let { dispatch , device , platformType , allDevices , currentDevice  } = param;
    if (allDevices !== undefined) {
        localStorage.setItem("allDeviceUser", JSON.stringify(allDevices));
    }
    const mode = platformType || (device === null || device === void 0 ? void 0 : device.platform_type) || localStorage.getItem("currentMode") || "";
    const deviceList = Array.isArray(allDevices) ? allDevices : [];
    let nextDevice = device || null;
    if (nextDevice && !(0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .isSelectableDevice */ .He)(nextDevice)) {
        nextDevice = (0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .pickPreferredSelectableDevice */ .oT)(deviceList, mode) || (0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .pickPreferredSelectableDevice */ .oT)(deviceList) || null;
    }
    localStorage.setItem("Basic", (nextDevice === null || nextDevice === void 0 ? void 0 : nextDevice.iCloud_username) ? 1 : 0);
    return (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_0__/* .switchDevice */ .m)({
        dispatch,
        deviceUser: nextDevice ? (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_2__/* .buildDeviceUserPayload */ .l)(nextDevice) : {},
        // 登录后的页面刷新必须保留当前物理设备，避免先以空设备状态渲染绑定流程。
        currentDevice: nextDevice && currentDevice !== undefined ? currentDevice : {},
        currentMode: mode,
        skipSelectionGuard: !nextDevice
    });
};


/***/ }),

/***/ 9839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ leaveBindingFlowIfNeeded; },
/* harmony export */   "b": function() { return /* binding */ isBindingFlowPath; }
/* harmony export */ });
/* harmony import */ var src_utils_appDeviceBridge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23077);

/** 与 UserLayout 清空侧栏菜单的绑定/选平台路径对齐（长路径优先匹配） */ const BINDING_FLOW_PATHS = [
    "/android/local/setup",
    "/android/nodevice-setup",
    "/android/classification",
    "/android/setup",
    "/ios/extreme-verification",
    "/ios/setup",
    "/setup"
];
/**
 * 当前是否处于绑定向导 / 选平台流程（含可选 locale 前缀，如 /fr/setup）。
 * @param {string} [pathname]
 * @returns {boolean}
 */ const isBindingFlowPath = (pathname)=>{
    if (!pathname) return false;
    const path = String(pathname).split("?")[0].replace(/\/$/, "") || "/";
    return BINDING_FLOW_PATHS.some((p)=>{
        if (path === p) return true;
        if (!path.endsWith(p)) return false;
        const prefix = path.slice(0, -p.length);
        // /fr/setup、/it-ch/ios/setup 等
        return /^\/[a-z]{2}(-[a-z]+)?$/i.test(prefix);
    });
};
/**
 * 若当前在绑定流，清 ontBindOrder 并跳到对应 Dashboard。
 * @param {Object} params
 * @param {{ pathname?: string, asPath?: string, push?: Function }} [params.router]
 * @param {string} [params.platformType]
 * @returns {boolean} 是否已执行离开跳转
 */ const leaveBindingFlowIfNeeded = function() {
    let { router , platformType  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const pathname = (router === null || router === void 0 ? void 0 : router.pathname) || (typeof (router === null || router === void 0 ? void 0 : router.asPath) === "string" ? router.asPath.split("?")[0] : "") || ( true ? window.location.pathname : 0);
    if (!isBindingFlowPath(pathname)) return false;
    try {
        localStorage.removeItem("ontBindOrder");
    } catch (e) {
    // ignore
    }
    const target = (0,src_utils_appDeviceBridge__WEBPACK_IMPORTED_MODULE_0__/* .getDashboardPathByPlatform */ .bI)(platformType);
    if (typeof (router === null || router === void 0 ? void 0 : router.push) === "function") {
        router.push(target);
    } else if (true) {
        window.location.assign(target);
    }
    return true;
};


/***/ }),

/***/ 80979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U9": function() { return /* binding */ clearReviewFormDraft; },
/* harmony export */   "V4": function() { return /* binding */ saveReviewFormDraft; },
/* harmony export */   "iV": function() { return /* binding */ clearReviewFormDraftsForLogout; },
/* harmony export */   "jT": function() { return /* binding */ getReviewFormDraftOwnerKey; },
/* harmony export */   "qf": function() { return /* binding */ getReviewFormDraft; }
/* harmony export */ });
/* unused harmony export clearAllReviewFormDrafts */
const DB_NAME = "spyx_review_form_draft";
const DB_VERSION = 1;
const STORE_NAME = "drafts";
const OWNER_STORAGE_KEY = "spyx_review_form_draft_owner";
const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;
const parseJson = (raw)=>{
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
};
const getReviewFormDraftOwnerKey = ()=>{
    var ref, ref1, ref2, ref3;
    if (false) {}
    const userData = parseJson(window.localStorage.getItem("userData"));
    const userInfo = parseJson(window.localStorage.getItem("userInfo"));
    const user = parseJson(window.localStorage.getItem("user"));
    const candidates = [
        userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.email,
        userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.id,
        userData === null || userData === void 0 ? void 0 : userData.email,
        userData === null || userData === void 0 ? void 0 : userData.id,
        userInfo === null || userInfo === void 0 ? void 0 : (ref2 = userInfo.data) === null || ref2 === void 0 ? void 0 : ref2.email,
        userInfo === null || userInfo === void 0 ? void 0 : (ref3 = userInfo.data) === null || ref3 === void 0 ? void 0 : ref3.id,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
        user === null || user === void 0 ? void 0 : user.email,
        user === null || user === void 0 ? void 0 : user.id
    ];
    const value = candidates.find((item)=>item !== undefined && item !== null && item !== "");
    return value == null ? "" : String(value);
};
const openDB = ()=>new Promise((resolve, reject)=>{
        if ( false || !window.indexedDB) {
            resolve(null);
            return;
        }
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onerror = ()=>reject(request.error);
        request.onsuccess = ()=>resolve(request.result);
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, {
                    keyPath: "platform"
                });
            }
        };
    });
const clearAllReviewFormDrafts = async function() {
    let { resetOwner =true  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const db = await openDB();
    if (!db) {
        if (resetOwner && "object" !== "undefined") {
            window.localStorage.removeItem(OWNER_STORAGE_KEY);
        }
        return;
    }
    return new Promise((resolve, reject)=>{
        const tx = db.transaction(STORE_NAME, "readwrite");
        tx.objectStore(STORE_NAME).clear();
        tx.oncomplete = ()=>{
            db.close();
            if (resetOwner && "object" !== "undefined") {
                window.localStorage.removeItem(OWNER_STORAGE_KEY);
            }
            resolve();
        };
        tx.onerror = ()=>{
            db.close();
            reject(tx.error);
        };
    });
};
const clearReviewFormDraftsForLogout = ()=>{
    void clearAllReviewFormDrafts();
};
const isDraftExpired = (draft)=>{
    if (!(draft === null || draft === void 0 ? void 0 : draft.updatedAt)) return true;
    return Date.now() - draft.updatedAt > DRAFT_TTL_MS;
};
const purgeExpiredDrafts = async ()=>{
    const db = await openDB();
    if (!db) return;
    return new Promise((resolve, reject)=>{
        const tx = db.transaction(STORE_NAME, "readwrite");
        const store = tx.objectStore(STORE_NAME);
        const request = store.openCursor();
        request.onsuccess = (event)=>{
            const cursor = event.target.result;
            if (!cursor) return;
            if (isDraftExpired(cursor.value)) {
                cursor.delete();
            }
            cursor.continue();
        };
        request.onerror = ()=>{
            db.close();
            reject(request.error);
        };
        tx.oncomplete = ()=>{
            db.close();
            resolve();
        };
        tx.onerror = ()=>{
            db.close();
            reject(tx.error);
        };
    });
};
const ensureDraftOwner = async ()=>{
    if (false) {}
    const currentOwner = getReviewFormDraftOwnerKey();
    const storedOwner = window.localStorage.getItem(OWNER_STORAGE_KEY);
    if (!currentOwner) {
        if (storedOwner) {
            await clearAllReviewFormDrafts({
                resetOwner: true
            });
        }
        return;
    }
    if (storedOwner && storedOwner !== currentOwner) {
        await clearAllReviewFormDrafts({
            resetOwner: false
        });
    }
    window.localStorage.setItem(OWNER_STORAGE_KEY, currentOwner);
};
const saveReviewFormDraft = async (platform, draft)=>{
    await ensureDraftOwner();
    await purgeExpiredDrafts();
    const db = await openDB();
    if (!db) return;
    const ownerKey = getReviewFormDraftOwnerKey();
    if (!ownerKey) return;
    return new Promise((resolve, reject)=>{
        const tx = db.transaction(STORE_NAME, "readwrite");
        tx.objectStore(STORE_NAME).put({
            platform,
            ownerKey,
            account: draft.account || "",
            notes: draft.notes || "",
            screenshotUrls: draft.screenshotUrls || [],
            updatedAt: Date.now()
        });
        tx.oncomplete = ()=>{
            db.close();
            resolve();
        };
        tx.onerror = ()=>{
            db.close();
            reject(tx.error);
        };
    });
};
const getReviewFormDraft = async (platform)=>{
    await ensureDraftOwner();
    await purgeExpiredDrafts();
    const db = await openDB();
    if (!db) return null;
    const ownerKey = getReviewFormDraftOwnerKey();
    if (!ownerKey) return null;
    return new Promise((resolve, reject)=>{
        const tx = db.transaction(STORE_NAME, "readonly");
        const request = tx.objectStore(STORE_NAME).get(platform);
        request.onsuccess = ()=>{
            const result = request.result || null;
            if (result && result.ownerKey && result.ownerKey !== ownerKey) {
                db.close();
                resolve(null);
                return;
            }
            if (result && isDraftExpired(result)) {
                db.close();
                void clearReviewFormDraft(platform);
                resolve(null);
                return;
            }
            db.close();
            resolve(result);
        };
        request.onerror = ()=>{
            db.close();
            reject(request.error);
        };
    });
};
const clearReviewFormDraft = async (platform)=>{
    const db = await openDB();
    if (!db) return;
    return new Promise((resolve, reject)=>{
        const tx = db.transaction(STORE_NAME, "readwrite");
        tx.objectStore(STORE_NAME).delete(platform);
        tx.oncomplete = ()=>{
            db.close();
            resolve();
        };
        tx.onerror = ()=>{
            db.close();
            reject(tx.error);
        };
    });
};


/***/ })

}]);